export const ADHESION_TIMEOUT = 2000
export const AUTOPLAY_CUSTOM = 3
export const AUTOPLAY_DESKTOP = 2
export const AUTOPLAY_MOBILE = 1
export const BELOW_THE_FOLD = 728
export const CATEGORY_SUBSTRING_LENGTH = 40
export const DEFAULT_VOLUME = 70
export const DURATION_FOR_IMPRESSION = 3000
export const IU_ID = 1030006
export const MIN_WIDTH_FOR_UPNEXT_DIALOG = 450
export const MINI_HEIGHT_MOBILE = 144
export const MINI_WIDTH_MOBILE = 256
export const MINI_HEIGHT_DESKTOP = 174
export const MINI_WIDTH_DESKTOP = 310
export const MOBILE_WIDTH_BREAKPOINT = 400
export const VOLUME_DIVISOR = 100.0
export const PROGRAMMATIC = 'programmatic'
export const USER = 'user'